import React, { useState, useEffect, useRef } from "react";
import { Button, Box, Typography } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { toast } from "react-toastify";
import VideoPreview from "./ImagePreview";

const supportedImageFileTypes = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
  "tiff",
  "tif",
  "ico",
  "heic",
  "heif",
  "avif",
];

const UploadVideo = ({ setGoalVideos, index, goalVideos, Admin_user_cond }) => {
  const [preview, setPreview] = useState(() =>
    goalVideos[index].club_img
      ? goalVideos[index].club_img instanceof File
        ? URL.createObjectURL(goalVideos[index].club_img)
        : goalVideos[index].club_img
      : null,
  );
  const videoRef = useRef();
  const formRef = useRef();

  useEffect(() => {
    if (formRef.current) {
      if (!goalVideos[index].goal) {
        formRef.current.reset();
      }
    }
  }, [goalVideos, videoRef]);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    let files = [];
    if (e.target.files) {
      files = e.target.files;
    } else if (e.dataTransfer.files) {
      files = e.dataTransfer.files;
    }

    if (file) {
      const fileType = file.type.split("/")[1];
      const fileExt = file.name.split(".").pop().toLowerCase();
      if (
        !supportedImageFileTypes.includes(fileType) &&
        !supportedImageFileTypes.includes(fileExt)
      ) {
        toast.error(`File : ${file.name} type not supported`);
        return;
      }

      // console.log(
      //   file,
      //   "this file is selected file and the orignal name will be in backend be ?"
      // );

      setPreview(URL.createObjectURL(file));
      setGoalVideos((prev) =>
        prev.map((p, i) =>
          i == index
            ? { ...p, club_img: file, created: true, checked: true }
            : { ...p },
        ),
      );
    } else {
      setGoalVideos((prev) =>
        prev.map((p, i) =>
          i == index
            ? { ...p, club_img: null, edited: true, checked: false }
            : { ...p },
        ),
      );

    }
  };

  return (
    <>
      <Box className="">
        <Box className={"upload-video"}>
          {preview ? (
            <Box className="multiple-videos">
              <VideoPreview
                preview={preview}
                setPreview={setPreview}
                setGoalVideos={setGoalVideos}
                index={index}
                Admin_user_cond={Admin_user_cond}
              />
            </Box>
          ) : (
            <Button
              className="upload-btn"
              onClick={() => {
                if (videoRef.current) {
                  videoRef.current.click();
                } else {
                }
              }}
              sx={{ color: "#ef364e" }}
            >
              <FileUploadIcon className="file-upload-icon" />
              <Typography className="">Upload club Image</Typography>
            </Button>
          )}
          <form ref={formRef}>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              name=""
              id="clubImage"
              style={{ display: "none" }}
              ref={videoRef}
              onChange={handleVideoChange}
            />
          </form>
        </Box>
      </Box>
    </>
  );
};

export default UploadVideo;
